import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {Area} from '../master-data/master-data.model';
import {MasterDataService} from '../master-data/master-data-service';

@Injectable({providedIn: 'root'})
export class AreasResolve  {
  private masterDataService = inject(MasterDataService);


  getAreas() {
    return this.masterDataService.getAreas();
  }

}
export const areasResolver: ResolveFn<Area[]> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(AreasResolve).getAreas();
  };
